import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-primary-500 blur-3xl" />
        <div className="absolute bottom-10 right-10 w-64 h-64 rounded-full bg-accent-500 blur-3xl" />
      </div>
      <div className="relative max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
          准备好开始你的阅读之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-xl mx-auto">
          加入500万+读者，体验布丁漫画下拉式无缝阅读的极致畅快，免费看韩漫国漫日漫全集。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/hanman"
            className="px-8 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            免费开始阅读
            <span className="w-4 h-4 inline-flex items-center justify-center ml-1">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-secondary-100 text-foreground-700 text-sm font-medium rounded-full hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解布丁漫画
          </Link>
        </div>
      </div>
    </section>
  );
}